import { ModeratedGroupsScreen } from 'app/features/group/screens'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

import { GroupNavCarousel } from 'app/features/group/components'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { userModeratedGroupsQuery } from 'app/features/group/queries'

export default function Page() {
  return <ModeratedGroupsScreen HeaderComponent={<GroupNavCarousel />} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req }) => {
  const user = req?.session?.user
  const client = initializeApollo({ token: user?.token })

  if (user) {
    await client.query({
      query: userModeratedGroupsQuery.query,
      variables: {
        ...userModeratedGroupsQuery.defaultVariables,
      },
    })
  }

  return addApolloState(client, {
    props: {
      user: user || null,
    },
  })
})
